import React, { useState } from 'react';
import { X, Copy } from 'lucide-react';
import noImage from '../assets/img/brand/noImage.png';
import { formatDateTime } from '../utils/formateDate';

// ─── Badge helpers (same as TradeInListingItems) ─────────────────────────────
const PromoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ flexShrink: 0 }}>
        <g clipPath="url(#clip0_9446_29093)">
            <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82"/>
            <path d="M5.58122 4.11743L4.14997 4.29681L4.09872 4.53431L4.37997 4.58618C4.56372 4.62993 4.59997 4.69618 4.55997 4.87931L4.09872 7.04681C3.97747 7.60743 4.16435 7.87118 4.60372 7.87118C4.94435 7.87118 5.33997 7.71368 5.51935 7.49743L5.57434 7.23743C5.44934 7.34743 5.26684 7.39118 5.1456 7.39118C4.97372 7.39118 4.91122 7.27056 4.9556 7.05806L5.58122 4.11743Z" fill="#5E6E82"/>
            <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82"/>
        </g>
        <defs>
            <clipPath id="clip0_9446_29093">
                <rect width="10" height="10" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
const PromoIcon2=()=>(<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <g clip-path="url(#clip0_9446_35969)">
    <path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_9446_35969">
      <rect width="18" height="18" fill="white"/>
    </clipPath>
  </defs>
</svg>)
const PromoPopup = ({ promo }) => (
    <div style={{
        position: 'absolute', bottom: 'calc(100% + 8px)', left: '0%',
        // transform: 'translateX(-50%)',
        borderRadius: '8px',
        border: '1px solid var(--Background-Gray, #E9ECEF)',
        background: 'var(--Gray-100, #F8F9FA)',
        display: 'inline-flex', flexDirection: 'column',
        padding: '10px', justifyContent: 'center', alignItems: 'flex-start',
        gap: '6px', minWidth: '240px',
        zIndex: 9, pointerEvents: 'none',
        minWidth:'355px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
    }}>
        <div style={{
            fontFamily: 'Montserrat', fontSize: '12px', fontStyle: 'normal',
            fontWeight: 700, lineHeight: 'normal',
            color: 'var(--Gray-900, #212529)',
        }}>
            Promotional Info
        </div>
        <div style={{
            fontFamily: 'Montserrat', fontSize: '12px', fontStyle: 'normal',
            fontWeight: 400, lineHeight: 'normal',
            color: 'var(--Gray-900, #212529)',
        }}>
            <span >Campaign Name: </span>{promo.campaignName}
        </div>
        <div style={{
            fontFamily: 'Montserrat', fontSize: '12px', fontStyle: 'normal',
            fontWeight: 400, lineHeight: 'normal',
            color: 'var(--Gray-900, #212529)',
        }}>
            <span >Promotional Period: </span>{promo.period}
        </div>
        <div style={{
            position: 'absolute', bottom: '-5px', left: '50%', transform: 'translateX(-50%)',
            width: 0, height: 0,
            borderLeft: '5px solid transparent', borderRight: '5px solid transparent',
            borderTop: '5px solid #E9ECEF',
        }} />
    </div>
);
const TypeBadge = ({ isPromotion }) => {
    const s = isPromotion
        ? { bg: '#CFE2FF', color: '#2C7BE5', border: '#2C7BE5' }
        : { bg: '#F8F9FA', color: '#6C757D', border: '#6C757D' };
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            padding: '2px 8px', borderRadius: '99px',
            fontSize: '11px', fontWeight: 600, fontFamily: 'Montserrat',
            background: s.bg, color: s.color,
            border: `1px solid ${s.border}`, whiteSpace: 'nowrap',
        }}>
            {isPromotion ? 'Promotional' : 'Normal'}
        </span>
    );
};

const ConditionBadge = ({ condition }) => (
    <span style={{
        borderRadius: '99px',
        border: '1px solid #FFEB00',
        background: '#FFEB00',
        display: 'inline-flex', height: '20px', minWidth: '40px',
        padding: '5px 10px', justifyContent: 'center', alignItems: 'center',
        color: '#212529', fontFamily: 'Montserrat', fontSize: '12px',
        fontWeight: 600, whiteSpace: 'nowrap',
    }}>
        {condition}
    </span>
);

// ─── Build deductions table rows from item's tier data ────────────────────────

const buildDeductions = (item) => {
    if (!item?.tiers) return [];
    const tiers = item.tiers;
    const rows = [];
    let id = 1;

    // Activation status rows
    const activationPrefix = item.itemCondition === 'New' ? 'Sealed and not ' : '';
    rows.push({ id: id++, deductionItem: `${activationPrefix}${tiers[0].label}`, dataType: 'Numeric', value: tiers[0].receiptValue });
    if (tiers[1]) rows.push({ id: id++, deductionItem: `Opened and Activated ${tiers[1].label}`, dataType: 'Numeric', value: tiers[1].receiptValue });
    if (tiers[2]) rows.push({ id: id++, deductionItem: `Opened and Activated ${tiers[2].label}`, dataType: 'Formula', value: tiers[2].receiptValue });
    if (tiers[3]) rows.push({ id: id++, deductionItem: `Opened and Activated ${tiers[3].label}`, dataType: 'Formula', value: tiers[3].receiptValue });

    // Receipt rows (unique labels only)
    const receiptLabels = [...new Set(tiers.filter(t => t.receiptLabel).map(t => t.receiptLabel))];
    receiptLabels.forEach(label => {
        rows.push({ id: id++, deductionItem: `${label} Official Receipt`, dataType: 'NA', value: 'NA' });
    });

    // Set Type rows
    tiers.filter(t => t.setTypeLabel).forEach(t => {
        const dataType = typeof t.setTypeValue === 'number' ? 'Numeric' : (t.setTypeValue || 'NA');
        rows.push({ id: id++, deductionItem: `${t.setTypeLabel} Set`, dataType, value: t.setTypeValue !== null && t.setTypeValue !== undefined ? t.setTypeValue : 'NA' });
    });

    // Screen condition rows (unique)
    [...new Set(tiers.filter(t => t.screenLabel).map(t => t.screenLabel))].forEach(label => {
        rows.push({ id: id++, deductionItem: label, dataType: 'NA', value: 'NA' });
    });

    // Exterior condition rows (unique, with B prefix)
    [...new Set(tiers.filter(t => t.exteriorLabel).map(t => t.exteriorLabel))].forEach(label => {
        rows.push({ id: id++, deductionItem: `B ${label}`, dataType: 'NA', value: 'NA' });
    });

    // Battery health rows (unique)
    [...new Set(tiers.filter(t => t.batteryLabel).map(t => t.batteryLabel))].forEach(label => {
        rows.push({ id: id++, deductionItem: label, dataType: 'NA', value: 'NA' });
    });

    // Accessories rows (unique)
    [...new Set(tiers.filter(t => t.accessoryLabel).map(t => t.accessoryLabel))].forEach(label => {
        rows.push({ id: id++, deductionItem: label, dataType: 'NA', value: 'NA' });
    });

    return rows;
};

// ─── Main component ───────────────────────────────────────────────────────────

const TradeInItemDrawer = ({ item, onClose }) => {
    const [tab, setTab] = useState('general');
    const [copied, setCopied] = useState(false);
    const [hoveredPromo, setHoveredPromo] = useState(false);
    const [hoveredPromoField, setHoveredPromoField] = useState(false);
    if (!item) return null;

    // Use real API deductions if available, otherwise fall back to tier-derived rows
    const deductions = (item.deductions && item.deductions.length > 0)
        ? item.deductions.map((d, idx) => ({
            id:            d.tradein_listing_item_deduction_id || idx + 1,
            deductionItem: d.deduction_item_name || d.deduction_code || '',
            dataType:      d.deduction_value_type || 'NA',
            value:         d.deduction_locked_value_text || d.deduction_formula_result || d.deduction_numeric_value || 'NA',
          }))
        : buildDeductions(item);

    // ── Copy handler ──────────────────────────────────────────────────────────
    const handleCopy = async (text) => {
        if (!text) return;
        if (window.isSecureContext && navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch {
                fallbackCopy(text);
            }
        } else {
            fallbackCopy(text);
        }
    };

    const fallbackCopy = (text) => {
        try {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) { setCopied(true); setTimeout(() => setCopied(false), 2000); }
        } catch (err) {
            console.error('Copy failed', err);
        }
    };

    // ── Shared field block ────────────────────────────────────────────────────
    const Field = ({ label, children, fullWidth = false }) => (
        <div
            className="field-block"
            style={{
                borderBottom: 'none',
                padding: '0px',
                display: 'flex',
                flexDirection: 'column',
                ...(fullWidth ? { gridColumn: '1 / -1' } : {}),
            }}
        >
            <div className="field-label">{label}</div>
            <div className="field-value">{children}</div>
        </div>
    );

    const na = <span style={{ color: '#ADB5BD' }}>NA</span>;

    // ── Table cell styles ─────────────────────────────────────────────────────
    const thStyle = {
        padding: '10px 12px',
        fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 700,
        color: '#212529', background: '#E9ECEF',
        textAlign: 'left', whiteSpace: 'nowrap',
        borderBottom: '1px solid #DEE2E6',
        borderLeft: 'none', borderRight: 'none',
    };
    const tdStyle = {
        padding: '10px 12px',
        fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400,
        color: '#212529', borderBottom: '1px solid #F0F0F0',
        borderLeft: 'none', borderRight: 'none',
    };

    return (
        <>
            {/* Overlay */}
            <div className="drawer-overlay" onClick={onClose} />

            {/* Drawer panel */}
            <div className="entity-drawer">

                {/* ── Header ── */}
                <div className="drawer-header" style={{ backgroundColor: '#F8F9FA',padding:"15px 20px" }}>
                    <div className="d-flex align-items-center gap-1">
                        <h3>Listing Item Info</h3>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                {/* ── Body ── */}
                <div className="main-drawer-inner" style={{marginTop:'52px'}}>

                    {/* Title row: image + storage + badges */}
                    <div
                        className="drawer-title d-flex align-items-center"
                        style={{
                            borderBottom: 'none',
                            paddingBottom: '0px',
                            boxShadow: 'none',
                            marginBottom: '0px',
                            gap: '8px',
                            flexWrap: 'nowrap',
                            paddingBottom:'15px'
                        }}
                     >
                        <img
                            src={item.tradein_image_url || noImage}
                            alt={item.sku_name}
                            style={{ width: 40, height: 40, objectFit: 'cover', flexShrink: 0 }}
                        />
                        <div>
                            {/* Storage name */}
                            <h2 style={{
                                textTransform: 'none', margin: 0, color: '#212529',
                                fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400,
                            }} className="pb-0">
                                {item.sku_name}
                            </h2>

                            {/* Colour swatch + name */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
                                <span style={{
                                    width: 10, height: 10, borderRadius: '50%',
                                    background: item.colorCode,
                                    border: '1.5px solid #fff',
                                    boxShadow: '0 0 0 1px #000',
                                    flexShrink: 0, display: 'inline-block',
                                }} />
                                <span style={{ fontSize: '10px', color: '#6C757D', fontFamily: 'Montserrat' }}>
                                    {item.color}
                                </span>
                            </div>

                            {/* Drawer-specific badges row — smaller font + padding, only for title area */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px', flexWrap: 'wrap' }}>
                                {/* Condition badge — drawer title style */}
                                <span style={{
                                    borderRadius: '99px',
                                    border: '1px solid #FFEB00',
                                    background: '#FFEB00',
                                    display: 'inline-flex', alignItems: 'center',
                                    padding: '1px 6px',
                                    color: '#212529', fontFamily: 'Montserrat',
                                    fontSize: '8px', fontWeight: 600, whiteSpace: 'nowrap',
                                }}>
                                    {item.itemCondition}
                                </span>

                                {/* Type badge — drawer title style */}
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center',
                                    padding: '1px 6px', borderRadius: '99px',
                                    fontSize: '8px', fontWeight: 600, fontFamily: 'Montserrat',
                                    background: item.isPromotion ? '#CFE2FF' : '#F8F9FA',
                                    color: item.isPromotion ? '#2C7BE5' : '#6C757D',
                                    border: `1px solid ${item.isPromotion ? '#2C7BE5' : '#6C757D'}`,
                                    whiteSpace: 'nowrap',
                                }}>
                                    {item.isPromotion ? 'Promotional' : 'Normal'}
                                </span>

                                {/* Promo info icon + tooltip — drawer title only */}
                                {item.isPromotion && (
                                    <span
                                        style={{ position: 'relative', display: 'inline-flex', cursor: 'pointer' }}
                                        onMouseEnter={() => setHoveredPromo(true)}
                                        onMouseLeave={() => setHoveredPromo(false)}
                                    >
                                        <PromoIcon />
                                        {hoveredPromo && (
                                            <div style={{
                                                position: 'absolute',
                                                bottom: 'calc(100% + 6px)',
                                                left: 0,
                                                borderRadius: '8px',
                                                border: '1px solid #E9ECEF',
                                                background: '#F8F9FA',
                                                display: 'inline-flex', flexDirection: 'column',
                                                padding: '10px',
                                                gap: '6px',
                                                minWidth: '220px',
                                                maxWidth: '280px',
                                                zIndex: 20,
                                                pointerEvents: 'none',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                                            }}>
                                                <div style={{ fontFamily: 'Montserrat', fontSize: '11px', fontWeight: 700, color: '#212529' }}>
                                                    Promotional Info
                                                </div>
                                                <div style={{ fontFamily: 'Montserrat', fontSize: '11px', fontWeight: 400, color: '#212529' }}>
                                                    <span style={{ fontWeight: 600 }}>Campaign Name: </span>{item.promo?.campaignName}
                                                </div>
                                                <div style={{ fontFamily: 'Montserrat', fontSize: '11px', fontWeight: 400, color: '#212529' }}>
                                                    <span style={{ fontWeight: 600 }}>Promotional Period: </span>{item.promo?.period}
                                                </div>
                                                <div style={{
                                                    position: 'absolute', bottom: '-5px', left: '8px',
                                                    width: 0, height: 0,
                                                    borderLeft: '5px solid transparent', borderRight: '5px solid transparent',
                                                    borderTop: '5px solid #E9ECEF',
                                                }} />
                                            </div>
                                        )}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>


                    {/* ── Tabs ── */}
                    <div
                        className="drawer-tabs"
                        style={{ padding: '20px 0px', gap: '20px', marginBottom: '0px', borderBottom: 'none' }}
                    >
                        <button
                            className={tab === 'general' ? 'active' : ''}
                            onClick={() => setTab('general')}
                            style={{padding:'10px'}}
                        >
                            General
                        </button>
                        <button
                            className={tab === 'deductions' ? 'active' : ''}
                            onClick={() => setTab('deductions')}
                            style={{padding:'10px'}}
                        >
                            Deductions
                        </button>
                    </div>

                    {/* ── Tab Content ── */}
                    <div className="drawer-content">

                        {/* ════════ GENERAL TAB ════════ */}
                        {tab === 'general' && (
                            <div className="tab-panel general-panel">
                                <div
                                    className="card-section"
                                    style={{ borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0,0,0,0.08)', overflow: 'hidden', marginBottom: '20px' }}
                                >
                                    {/* Card header */}
                                    <div
                                        className="card-header"
                                        style={{
                                            backgroundColor: '#F8F9FA',
                                            padding: '15px 20px',
                                            fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600,
                                            color: '#212529', display: 'flex', alignItems: 'center',
                                            borderRadius: '12px 12px 0 0', height: '50px', borderBottom: 'none',
                                        }}
                                    >
                                        Basic Info
                                    </div>

                                    {/* Card body */}
                                    <div
                                        className="card-body"
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            padding: '10px 20px',
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(2, 1fr)',
                                            gap: '20px',
                                        }}
                                    >
                                        {/* Image | Storage */}
                                        <Field label="Image">
                                            <img
                                                src={item.tradein_image_url || noImage}
                                                alt={item.storage}
                                                style={{ width: 32, height: 32, objectFit: 'cover' }}
                                            />
                                        </Field>
                                        <Field label="Storage">
                                            {item.storage || na}
                                        </Field>

                                        {/* Color | Condition */}
                                        <Field label="Color">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {/* {item.colorCode && (
                                                    <span style={{
                                                        width: 12, height: 12, borderRadius: '50%',
                                                        background: item.colorCode,
                                                        border: '1.5px solid #fff',
                                                        boxShadow: '0 0 0 1px #aaa',
                                                        flexShrink: 0, display: 'inline-block',
                                                    }} />
                                                )} */}
                                                {item.color || na}
                                            </div>
                                        </Field>
                                        <Field label="Condition">
                                            <ConditionBadge condition={item.itemCondition} />
                                        </Field>
                                        <Field label="Trade-in Status">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <TypeBadge isPromotion={item.isPromotion} />
                                                {item.isPromotion && (
                                                    <span
                                                        style={{ position: 'relative', display: 'inline-flex', cursor: 'pointer' }}
                                                        onMouseEnter={() => setHoveredPromoField(true)}
                                                        onMouseLeave={() => setHoveredPromoField(false)}
                                                    >
                                                        <PromoIcon2 />
                                                        {hoveredPromoField && <PromoPopup promo={item.promo} />}
                                                    </span>
                                                )}
                                            </div>
                                        </Field>
                                        {/* Base Price — beside Trade-in Status */}
                                        <Field label="Base Price">
                                            {item.basePrice === 'WhatsApp'
                                                ? 'WhatsApp'
                                                : item.basePriceRaw != null
                                                    ? `SGD ${item.basePriceRaw.toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                                    : na}
                                        </Field>

                                        

                                        {/* Open ID — full width */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', gridColumn: '1 / -1', padding: '0px', display: 'flex', flexDirection: 'column' }}
                                        >
                                            <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                            <div className="field-value" style={{ wordBreak: 'break-all' }}>
                                                {item.uuid ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span
                                                            style={{ color: '#0D6EFD', cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
                                                            onClick={() => handleCopy(item.uuid)}
                                                        >
                                                            {item.uuid}
                                                            <Copy size={13} style={{ cursor: 'pointer', color: '#0D6EFD', marginLeft: '6px' }} />
                                                        </span>
                                                        {copied && <span style={{ fontSize: '12px', color: '#0D6EFD' }}>Copied!</span>}
                                                    </div>
                                                ) : na}
                                            </div>
                                        </div>

                                        {/* Created By | Created Time */}
                                        <Field label="Created By">{item.created_by || na}</Field>
                                        <Field label="Created Time">{formatDateTime(item.created_time) || na}</Field>

                                        {/* Last Modified By | Last Modified Time */}
                                        <Field label="Last Modified By">{item.last_modified_by || na}</Field>
                                        <Field label="Last Modified Time">{formatDateTime(item.last_modified_time) || na}</Field>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ════════ DEDUCTIONS TAB ════════ */}
                        {tab === 'deductions' && (
                            <div
                                className="card-section"
                                style={{  boxShadow: '0px 4px 12px rgba(0,0,0,0.08)', overflow: 'hidden' }}
                            >
                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...thStyle, padding: '10px' }}>ID</th>
                                                <th style={{ ...thStyle, padding: '10px' }}>Deduction Item</th>
                                                <th style={{ ...thStyle, padding: '10px' }}>Data Type</th>
                                                <th style={{ ...thStyle, padding: '10px', textAlign: 'left' }}>Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deductions.map((row, idx) => {
                                                const rowBg = idx % 2 === 0 ? '#FFFFFF' : '#F8F9FA';
                                                return (
                                                <tr key={row.id} style={{ background: rowBg }}>
                                                    <td style={{ ...tdStyle, background: rowBg, color: '#212529' }}>{row.id}</td>
                                                    <td style={{ ...tdStyle, background: rowBg }}>{row.deductionItem}</td>
                                                    <td style={{ ...tdStyle, background: rowBg, color: '#212529' }}>{row.dataType}</td>
                                                    <td style={{ ...tdStyle, background: rowBg, textAlign: 'left', color:"#212529" }}>
                                                        {row.value !== null && row.value !== undefined ? String(row.value) : 'NA'}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default TradeInItemDrawer;
